import React from "react";
import styles from "./styles.module.scss";
import EmptyData from "./EmptyData";

export default function Careers({ children, isEmpty = true }) {
    return <div className={styles.root}>
        <div className="title-block">
            <div className="container">
                <h1 className={styles.title}>Careers at Apphud</h1>
            </div>
        </div>
        <div className={`container ${styles.container}`}>
            { isEmpty
                ? <EmptyData />
                : <>
                    <p className={styles.subtitle}>
                        <b>Join our team and create the best mobile purchase platform with us!</b>
                    </p>
                    {children}
                </>
            }
        </div>
    </div>
}
